import React from 'react'
import { useRouter } from 'next/router'

import { useToast } from '@wartek-id/toast'

import {
  useApiCompetencyMappingResult,
  useMutateApiCompetencyMappingCertificate,
} from 'api/competency-mapping/useAPICompetencyMapping'
import { useUserGroupSjt } from 'utils/hooks/useUserGroup'
import ForbiddenPage from '../components/ForbiddenPage'
import PeriodGuard from '../components/PeriodGuard'
import LoadingState from '../components/LoadingState'
import CertificatePageContent from '../components/CertificatePageContent'

const CERTIFICATE_REFETCH_INTERVAL_MS = 10000

const Certificate = ({ currentDateTimeServer }) => {
  const containerRef = React.useRef<HTMLDivElement>(null)

  const refetchInterval = (data) => {
    if (data?.data.certificateState === 'IN_PROGRESS')
      return CERTIFICATE_REFETCH_INTERVAL_MS

    return false
  }
  const router = useRouter()
  const toast = useToast()
  const { hasAccess: hasNecessaryRole, isLoading: isLoadingNecessaryRole } =
    useUserGroupSjt()
  const isUjikomWhitelisted = !isLoadingNecessaryRole && hasNecessaryRole
  const assesmentType = 'SJT'
  const {
    isLoading: isLoadingResult,
    data: UjikomDataResult,
    isSuccess: isSuccessResult,
    refetch: refetchResult,
  } = useApiCompetencyMappingResult(
    assesmentType,
    isUjikomWhitelisted,
    refetchInterval,
    (error) => {
      if (error.response) {
        const errorResponseMessage = `${error.response?.data?.message}`
        if (
          errorResponseMessage.toLowerCase() ===
          'integrity pact still unchecked'
        ) {
          toast({
            message:
              'Klik Ikuti Uji Kompetensi dan centang Pakta Integritas terlebih dahulu',
          })
        }
      }

      router.replace('/pemetaan-kompetensi/')
    }
  )

  const generateCertificate =
    useMutateApiCompetencyMappingCertificate(assesmentType)

  if (!isUjikomWhitelisted) return <ForbiddenPage />

  if (isLoadingNecessaryRole || isLoadingResult)
    return <LoadingState title="Halaman sedang dimuat..." />

  if (
    isSuccessResult &&
    UjikomDataResult.data.certificateState === 'NOT_CREATED' &&
    generateCertificate.isIdle &&
    !generateCertificate.isSuccess
  ) {
    generateCertificate.mutate(
      {},
      {
        onSuccess: () => {
          refetchResult()
        },
      }
    )
  }

  if (
    UjikomDataResult.data.certificateState === 'NOT_CREATED' ||
    UjikomDataResult.data.certificateState === 'IN_PROGRESS'
  )
    return <LoadingState title="Sertifikat sedang dimuat..." />

  return (
    <div
      className="relative flex flex-col h-max max-w-ujikom mx-auto bg-gray-10"
      ref={containerRef}
    >
      <PeriodGuard
        fullPageLoading
        currentDateTimeServer={currentDateTimeServer}
      >
        <CertificatePageContent isUjikomWhitelisted={isUjikomWhitelisted} />
      </PeriodGuard>
    </div>
  )
}

export default Certificate
